import { atomFamily } from "recoil";
import { localStorageEffect } from "../../shared/state/local-storage.effect";

export const selectedUnitIdsState = atomFamily<string[], string>({
  key: "camping.rent.selectedUnitIds",
  default: [],
  effects: [localStorageEffect()],
});
